module.exports = __webpack_public_path__ + "static/media/Recruitments_Welfare02.6ae0cbd0.png";